import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsUserMgmt;

let rf="0";
class Cast_Settings extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={ listUsers:[],stSettings:{}};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      clsUserMgmt=this;
      }

      resetFilters(){
        $("#ser_text").val("");
        clsUserMgmt.getUsers();
      }


      getUsers(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getMachineUsers"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"gb_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:"2"});
        //map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        //alert(status);
        /*
        if(status!=="0"){
          map.push({name:"status",value:status});
        }
        not required as of now
        */
        map.push({name:"app_user_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getMachineUsers";
        CallMapMethod_CBack(clsUserMgmt,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsUserMgmt.setState({listUsers:listData},()=>{
                  //window.getPagination("#tbData");
                  clsUserMgmt.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsUserMgmt.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful",smg,false);
          //window.location.reload();
          //clsUserMgmt.getUsers();
          //$("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Invalid Request",smg,false);
        }
        // alert(data);
      }
okSuccCreditB(data,msg){
  //alert(data);
  if(data===-10){
    Custom_Alert("Validation","Fill Required Fileds",false);
    
    return;
  }else{
    //alert(data+msg);
    Custom_Alert("Completed",msg,true);
    
  }
    
}


getActiveDays(){
  var map=[];
  map.push({name:"curl_type",value:"getGlobalSettings"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
 
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getGlobalSettings";
  CallMapMethod_CBack(clsUserMgmt,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
         let lsData=JSON.parse(data);
         clsUserMgmt.setState({stSettings:lsData})
        }
  });
}
           
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getActiveDays();
//this.getUsers();

}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
  
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><b>Active Machine Settings(in Days)</b></h3>
                
                {/* <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divCreateUser" href="javascript:void(0)">Add New</a> */}
              </div>
               {/*  pdf object */}
            <div class="card-body">
            <form id="frmChangePwd" name="frmChangePwd">
            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="globalSettings" />
                            <input type="hidden" name="m_type" id="m_type" value="globalSettings" />
                            <input type="hidden" name="type_id" id="type_id" value="2" />
                            <input type="hidden" name="local_token" id="local_token" value={userObject[0].id} />

                            <div className="row">

                            <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Days *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" id="days" name="days" defaultValue={this.state.stSettings?.active_days} className="form-control required" placeholder="Days" />
                                            </div>
                                        </div>
                            </div>

                           

                            <div className='col-lg-4 col-md-4'>
                            <button type="button" className="btn _btnSetColor btn-danger">Update Now</button>
                            </div>


                            </div>

            </form>


            </div>
             
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>

    
          </div>)
      }
}
export default Cast_Settings;